import { render } from "./EnrolleeProviderDependantOnboardComponent.vue?vue&type=template&id=799344f0&scoped=true"
import script from "./EnrolleeProviderDependantOnboardComponent.vue?vue&type=script&lang=js"
export * from "./EnrolleeProviderDependantOnboardComponent.vue?vue&type=script&lang=js"

import "./EnrolleeProviderDependantOnboardComponent.vue?vue&type=style&index=0&id=799344f0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-799344f0"]])

export default __exports__